import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

export const CustomTwitterIcon = (props: {}): JSX.Element => (
    <SvgIcon {...props}>
        <path
            d={
                'M18.2439 2.75049H21.5519L14.3249 11.0105L22.8269 22.2505H16.1699L10.9559 15.4335L4.98991 22.2505H1.67991L9.40991 13.4155L1.25391 2.75049H8.07991L12.7929 8.98149L18.2439 2.75049ZM17.0829 20.2705H18.9159L7.08391 4.62649H5.11691L17.0829 20.2705Z'
            }
        />
    </SvgIcon>
);
